<div
    class="postkorb-nachricht-dialog__body"
    *ngIf="postkorbNachricht$ | async; let postkorbNachricht">
    <p>Eingangsdatum: {{ postkorbNachricht.zustellzeitpunkt }}</p>
    <p [innerHTML]="postkorbNachricht.nachricht | safePostkorbNachrichtenHtml"></p>
</div>
